import { PropsWithChildren } from "react";

import Box from "@mui/material/Box";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import type { ContactSection } from "./ContactSection";

interface Props extends PropsWithChildren {
  onClose(): void;
  open: boolean;
  contacts: ContactSection[];
}

export const ContactTooltip = ({
  children,
  onClose,
  open,
  contacts,
}: Props) => {
  return (
    <ClickAwayListener onClickAway={onClose}>
      <Box>
        <Tooltip
          PopperProps={{
            disablePortal: true,
          }}
          onClose={onClose}
          open={open}
          title={
            <Box>
              {contacts.map(({ name, phone, email }, index, array) => (
                <Box
                  key={name}
                  sx={{
                    whiteSpace: "nowrap",
                  }}>
                  <Typography variant="subtitle1" gutterBottom>
                    {name}
                  </Typography>
                  {!!phone && (
                    <Typography variant="body2" color="textPrimary">
                      {phone}
                    </Typography>
                  )}
                  <Link
                    underline="hover"
                    variant="body2"
                    color="secondary"
                    href={`mailto:${email}`}
                    target="_blank"
                    rel="noreferrer">
                    {email}
                  </Link>
                  {index !== array.length - 1 && (
                    <Divider
                      sx={{
                        mb: 1,
                        mt: 1,
                      }}
                      variant="fullWidth"
                    />
                  )}
                </Box>
              ))}
            </Box>
          }>
          <Box>{children}</Box>
        </Tooltip>
      </Box>
    </ClickAwayListener>
  );
};

export default ContactTooltip;
